import { render, staticRenderFns } from "./info_issue.vue?vue&type=template&id=2dfd3553&scoped=true&"
import script from "./info_issue.vue?vue&type=script&lang=js&"
export * from "./info_issue.vue?vue&type=script&lang=js&"
import style0 from "./info_issue.vue?vue&type=style&index=0&lang=less&"
import style1 from "./info_issue.vue?vue&type=style&index=1&id=2dfd3553&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dfd3553",
  null
  
)

export default component.exports